import {
  FormControlLabel,
  Grid,
  InputAdornment,
  lighten,
  makeStyles,
  Switch,
  TextField,
  Toolbar,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { lang } from "i18nLang";
import { observer } from "mobx-react";
import { SendToBillingStore as Store } from "store";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    width: "100%",
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.primary.main,
          backgroundColor: lighten(theme.palette.primary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.primary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
  grayText: {
    color: theme.palette.gray?.[600],
  },
}));

/** Barra de ações da tabela de 'Seleção de itens' com pesquisar produto e rateio automático. */
const ProdutcItemsToolbar = observer(() => {
  const classes = useToolbarStyles();

  const handleChangeSearch = (event) => {
    const newValue = event.target.value;
    Store.setProductsSearchTerm(newValue);
  };

  const handleChangeManualApportionig = (event) => {
    const newValue = event.target.checked;
    Store.setManualApportionmentAndUpdateProductsApportionment(newValue);
  };

  return (
    <Toolbar className={classes.root}>
      <Grid item sm>
        <TextField
          id="search"
          type="search"
          value={Store.productsSearchTerm}
          placeholder={lang("search")}
          margin="normal"
          variant="outlined"
          fullWidth
          size={"small"}
          onChange={handleChangeSearch}
          onKeyDown={(ev) => ev.stopPropagation()}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item sm={3} md={2} className="pl-2">
        <FormControlLabel
          className={classes.grayText}
          control={
            <Switch
              checked={Store.manualApportioning}
              onChange={handleChangeManualApportionig}
              size="small"
              color="primary"
            />
          }
          label={lang(
            Store.manualApportioning
              ? "billing.manualApportioning"
              : "billing.autoApportioning"
          )}
        />
      </Grid>
    </Toolbar>
  );
});

export default ProdutcItemsToolbar;
